<template>
  <div>
    <dl id='beforeWeBeginDL'>
      <dt class='row no-gutters'><div><img alt='' src='../assets/images/checkmark.png' style=''/></div><span class='col'>{{$t("text.page1_req1")}}</span></dt>
      <dd v-html='$t("text.page1_req1_text")'></dd>
      <dt v-if="this.$store.state.site==='cibc'" class='row no-gutters'><div><img alt='' src='../assets/images/checkmark.png' style='margin-right:25px'/></div><span class='col'>{{$t("text.page1_req2")}}</span></dt>
      <dt v-if="this.$store.state.site!=='cibc'&&showBC===true" class='row no-gutters'><div><img alt='' src='../assets/images/checkmark.png' style='margin-right:25px'/></div><span class='col'>{{$t("text.page1_req4")}}</span></dt>
      <dt v-if="this.$store.state.site!=='cibc'&&showBC===false" class='row no-gutters'><div><img alt='' src='../assets/images/checkmark.png' style='margin-right:25px'/></div><span class='col'>{{$t("text.page1_req4_new")}}</span></dt>
      <dd v-if="this.$store.state.site!=='cibc'&&showBC===true" v-html='$t("text.page1_req4_text")'></dd>
      <dd v-if="this.$store.state.site!=='cibc'&&showBC===false" v-html='$t("text.page1_req4_text_new")'></dd>
    </dl>
    <br/>
  </div>
</template>

<script>
import { initKeywords } from "../utils/keywords.js";
import { eventPageView } from "../utils/adobeAnalytics.js";
import generalConfig from "../config/generalConfig.js";

export default {
  computed: {
    showBC: {
      get() {
        const gc = generalConfig();
        // alert(gc.showBCAfter);
        return this.$moment().isSameOrAfter(gc.showBCAfter);
      }
    }
  },
  mounted(){
    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}
    
    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    // Initialize keyword tooltips
    initKeywords(this);

    // Adobe Analytics
    eventPageView(this, "");
  },
}
</script>


<style>
#beforeWeBeginDL dt img {
margin-left:20px; 
margin-right:25px;
margin-top:-5px;
}
#beforeWeBeginDL dd {
  margin-left:76px;
  margin-bottom: 25px;
}
.textReqTitle{
  font-family: Glober-Regular, Arial, Helvetica, sans-serif;
  font-weight:bold;
}
.textReqText {
  font-family: Glober-Regular, Arial, Helvetica, sans-serif;
}
</style>

